const en = {
  navbar: {
    trackCase: "Track a case",
  },
};

export default en;
